module.exports = __webpack_public_path__ + "static/media/other.3cadf52c.mp3";